"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECustomDataEntity = void 0;
const EnumObject_1 = require("../../../../core/domain/EnumObject");
const enumValues = {
    ORGS: "orgs",
    USERS: "users",
    PROJECTS: "projects",
    UNITS: "units",
    MODEL_VERSION: "modelVersion",
};
class ECustomDataEntity extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static create(p) {
        return new ECustomDataEntity(p);
    }
}
exports.ECustomDataEntity = ECustomDataEntity;
ECustomDataEntity.V = enumValues;
//# sourceMappingURL=ECustomDataEntity.js.map